import React from 'react';

/**
 * DrivingCarAnimation Component
 * 
 * Renders the Pabst Teknik service car driving smoothly across the top line of the footer
 * with realistic bounce animation, headlight glow, and exhaust smoke effects.
 */
export default function DrivingCarAnimation() {
  return (
    <div 
      aria-hidden="true"
      className="absolute -top-[42px] sm:-top-[52px] md:-top-[60px] left-0 w-full overflow-x-clip pointer-events-none select-none z-20 h-[48px] sm:h-[58px] md:h-[68px]"
    >
      {/* Animated Van Container */}
      <div className="animate-drive-van absolute bottom-0 left-0 w-[110px] sm:w-[135px] md:w-[155px]">
        {/* Subtle vehicle bounce / road vibration animation */}
        <div className="animate-car-bounce relative w-full">
          
          {/* Headlight beam projection */}
          <div className="absolute bottom-2 sm:bottom-3 -right-7 sm:-right-9 w-10 sm:w-14 h-4 sm:h-6 bg-gradient-to-r from-amber-300/45 via-yellow-100/20 to-transparent blur-[2px] rounded-r-full pointer-events-none" />

          {/* Subtle tire contact shadow right on the footer line */}
          <div className="absolute -bottom-1 left-2 right-2 h-1 bg-black/40 blur-[1.5px] rounded-full" />

          {/* Exhaust smoke puffs at the rear */}
          <div className="absolute bottom-2 -left-2 flex items-center justify-center pointer-events-none">
            <span className="absolute w-2 h-2 rounded-full bg-slate-400/40 blur-[1px] animate-exhaust-1" />
            <span className="absolute w-2.5 h-2.5 rounded-full bg-slate-400/30 blur-[1.5px] animate-exhaust-2" />
            <span className="absolute w-1.5 h-1.5 rounded-full bg-slate-400/20 blur-[1px] animate-exhaust-3" />
          </div>

          {/* Service Car Image Asset */}
          <img
            src="https://assets.auxodev.dk/assets/a2859b51-1b34-4d15-a97b-9fa5c0c0144f/chatgpt-image-26-aug-2026-14-11-21.png"
            alt="Pabst Teknik rullende servicevogn på vej til portservice"
            className="w-full h-auto object-contain drop-shadow-[0_5px_8px_rgba(0,0,0,0.5)]"
            loading="eager"
          />
        </div>
      </div>
    </div>
  );
}
